import { render } from "./price-summary.component.vue?vue&type=template&id=5107d1c8&ts=true"
import script from "./price-summary.component.vue?vue&type=script&lang=ts"
export * from "./price-summary.component.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__